module.exports = __webpack_public_path__ + "img/top.c493101c.png";